import { useEffect, useMemo, useState } from "react";
import { inspectionsAPI } from "../services/api";
import { useProjectContext } from "./useProjectContext";

export const useInspections = () => {
  const { activeProject } = useProjectContext();

  const [inspections, setInspections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);

  const projectId = activeProject?.id;

  const load = async () => {
    if (!projectId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await inspectionsAPI.listByProject(projectId);
      setInspections(res.data || []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  const create = async (payload) => {
    if (!projectId) throw new Error("No active project selected");
    setCreating(true);
    setError(null);
    try {
      const res = await inspectionsAPI.create(projectId, payload);
      // optimistic append
      setInspections((prev) => [res.data, ...prev]);
      return res.data;
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setCreating(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  const stats = useMemo(() => {
    const total = inspections.length;
    const draft = inspections.filter(i => (i.status || "").toLowerCase() === "draft").length;
    const submitted = inspections.filter(i => (i.status || "").toLowerCase() === "submitted").length;
    const approved = inspections.filter(i => (i.status || "").toLowerCase() === "approved").length;
    return { total, draft, submitted, approved };
  }, [inspections]);

  return { inspections, loading, creating, error, reload: load, create, stats };
};
